import React, { useEffect } from 'react';
import { Modal, Form, Col, Row, Input } from 'antd';

function NotificationModal(props: any) {
	const { visible, onClose, onSave, saving, notification, afterClose } = props;

	const [form] = Form.useForm();

	function saveForm(values: any) {
		if (notification?.id) {
			values.id = notification.id;
		}

		onSave(values);
	}

	useEffect(() => {
		form.resetFields();
		form.setFieldsValue({
			title: notification?.title || '',
			description: notification?.description || '',
			action_link: notification?.action_link || '',
		});
	}, [visible]);

	return (
		<Modal
			okText="Save"
			cancelText="Cancel"
			title={notification?.id ? 'Edit Notification' : 'New Notification'}
			okButtonProps={{ loading: saving }}
			visible={visible}
			afterClose={afterClose}
			onOk={() => form.submit()}
			destroyOnClose={true}
			onCancel={onClose}
		>
			<Form form={form} id="notificationForm" onFinish={saveForm} layout="vertical">
				<Row gutter={16}>
					<Col span={24}>
						<Form.Item initialValue={notification?.title || ''} name="title" label="Title">
							<Input />
						</Form.Item>
					</Col>
					<Col span={24}>
						<Form.Item
							initialValue={notification?.description || ''}
							name="description"
							label="Description"
						>
							<Input.TextArea />
						</Form.Item>
					</Col>
					<Col span={24}>
						<Form.Item
							initialValue={notification?.action_link || ''}
							name="action_link"
							label="Action Link"
						>
							<Input />
						</Form.Item>
					</Col>
				</Row>
			</Form>
		</Modal>
	);
}

export default NotificationModal;
